import { useContext } from 'react';
import HQPlayerStateContext from '../contexts/HQPlayerStateContext';

export default function useHQPlayerStateContext() {
  return useContext(HQPlayerStateContext);
}
